import { render } from "./PasswordResetView.vue?vue&type=template&id=c8e0144e&scoped=true"
import script from "./PasswordResetView.vue?vue&type=script&lang=js"
export * from "./PasswordResetView.vue?vue&type=script&lang=js"

import "./PasswordResetView.vue?vue&type=style&index=0&id=c8e0144e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8e0144e"]])

export default __exports__